import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import LeadForm from "@/components/common/LeadForm";

const Quote = () => (
  <div>
    <PageHeader
      eyebrow="Request a Quote"
      title="Get a tailored quotation"
      subtitle="Share your machine, service or project scope and we'll prepare a detailed, transparent quotation for you."
      image="https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400"
    />
    <section className="py-12 md:py-20">
      <div className="max-w-[760px] mx-auto px-6 md:px-12">
        <Reveal className="bg-white border border-[#0055FF]/30 rounded-2xl p-8 md:p-10">
          <LeadForm kind="quote" />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Quote;
